import { matchPath } from 'react-router'
import { settings } from './conf'

export const encodeAccommmodationList = (accommodationList) => {
  if (typeof accommodationList === 'string') return accommodationList
  let url
  switch (accommodationList.type) {
    case 'waypoint':
      url = 'w-' + accommodationList.quadhash
      break
    case 'step':
      url = 's-' + accommodationList.trail_id + '-' + accommodationList.step_id
      break
    case 'trail':
      url = 't-' + accommodationList.trail_id
      break
    default:
      throw new Error(`invalid type ${accommodationList.type}`)
  }
  return url
}

export const decodeAccomodationList = (url) => {
  const parts = url.split('-')
  const accommodationList = {}
  switch (parts[0]) {
    case 'w':
      accommodationList.type = 'waypoint'
      accommodationList.quadhash = parts[1]
      break
    case 's':
      accommodationList.type = 'step'
      accommodationList.trail_id = parts[1]
      accommodationList.step_id = parts[2]
      break
    case 't':
      accommodationList.type = 'trail'
      accommodationList.trail_id = parts[1]
      break
    default:
      throw new Error(`invalid type ${parts[0]}`)
  }
  return accommodationList
}

export const matchPathname = (pathname) => {
  const match = matchPath(pathname, {
    path: [
      reverse(':route_id', ':trail_id', ':accommodationList'),
      reverse(':route_id', ':trail_id'),
      reverse(':route_id', null, ':accommodationList'),
      reverse(':route_id')
    ]
  })
  const route_id = (match && match.params.route_id) ? match.params.route_id : null
  const trail_id = (match && match.params.trail_id) ? parseInt(match.params.trail_id) : null
  const accommodationList = (match && match.params.accommodationList) ? decodeAccomodationList(match.params.accommodationList) : null
  if (accommodationList) {
    accommodationList.route_id = route_id
  }

  return {
    route_id: route_id,
    trail_id: trail_id,
    accommodationList: accommodationList
  }
}

export const reverse = (route_id, trail_id, accommodationList) => {
  let url
  if (!route_id) {
    return '/'
  }
  if (trail_id) {
    url = `/${route_id}/t-${trail_id}/`
  } else {
    url = `/${route_id}/`
  }
  if (accommodationList) {
    url += `s-${encodeAccommmodationList(accommodationList)}/`
  }
  return url
}

const BASE_NAME = settings.BASE_NAME.substring(0, settings.BASE_NAME.length - 1)

export const absoluteUrl = (url, origin) => {
  return new URL(BASE_NAME + url, origin || window.location.origin)
}

export default { reverse, matchPathname }
